module.exports = __webpack_public_path__ + "static/media/Maintenance-art.cc541540.png";